import { render } from "./BagItem02.vue?vue&type=template&id=4918e7d4&scoped=true"
import script from "./BagItem02.vue?vue&type=script&lang=js"
export * from "./BagItem02.vue?vue&type=script&lang=js"

import "./BagItem02.vue?vue&type=style&index=0&id=4918e7d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4918e7d4"]])

export default __exports__